import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {URLS} from '../../../environments/environment';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(private http: HttpClient) {
  }

  getOrders() {
    return this.http.get(URLS.API + 'orders', {withCredentials: true});
  }

  getOrdersCountByUser() {
    return this.http.get(URLS.API + 'orders/getOrdersCountByUser', {withCredentials: true})
  }

  InsertOrdersCountByUser() {
    return this.http.get(URLS.API + 'orders/InsertOrdersCountByUser', {withCredentials: true})
  }


  getOrderNotifications(orderID: string) {
    return this.http.get(URLS.API + 'orders/notifications', {params: {id: orderID}, withCredentials: true}).pipe(map((res: any) => {
      return res.data;
    }));
  }

  createNewOrder(order: any, forPdf: boolean = false) {
    return this.http.post(URLS.API + 'orders/new', {order}, {withCredentials: true});
  }

  createNewBasicOrder(order: any, forPdf: boolean = false) {
    return this.http.post(URLS.API + 'orders/new-basic', {order}, {withCredentials: true});
  }

  getSingleOrder(id: any) {
    return this.http.get(URLS.API + 'orders/get', {params: {id}, withCredentials: true});
  }

  exportOrderToPdf(order: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(URLS.APIPDF + 'orders/pdf', {params: {id: order.id}, headers, responseType: 'blob', withCredentials: true});
  }

  updateOrder(order: any) {
    return this.http.post(URLS.API + 'orders/update', {order}, {withCredentials: true});
  }

  setOrderStatus(order: any) {
    return this.http.post(URLS.API + 'orders/set-inprogress', {order}, {withCredentials: true});
  }

  getFileTypes() {
    return this.http.get(URLS.API + 'orders/get-file-types', {withCredentials: true});
  }

  deleteFile(id: string) {
    return this.http.delete(URLS.API + 'files/delete', {params: {id}, withCredentials: true});
  }

  downloadFile(id: any) {
    return this.http.get(URLS.API + 'orders/file-download', {responseType: 'blob', params: {id}, withCredentials: true});
  }

  viewFile(file: any) {
    return this.http.get(URLS.API + 'orders/file/view', {params: {id: file.id}, withCredentials: true});
  }


  getOrderFiles(orderID: any) {
    return this.http.get(URLS.API + 'orders/get-order-files', {params: {orderID}, withCredentials: true});
  }

  getOrderRequestFiles(orderID: any) {
    return this.http.get(URLS.API + 'orders/get-order-requestfiles', {params: {orderID}, withCredentials: true});
  }

  sendMessage(orderID: number, message: string, files?: any[]) {
    return this.http.post(URLS.API + 'orders/send-message', {orderID, message, files}, {withCredentials: true});
  }
}
